module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/map_stay-fdb6f0f6edc806d4df77475e469577fe.png";